document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-upsell-add]');
  if (!btn || btn.disabled) return;

  const cart = document.querySelector('cart-drawer');
  btn.disabled = true;

  try {
    const formData = new FormData();
    formData.append('id', btn.dataset.variantId);
    formData.append('quantity', 1);
    formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
    formData.append('sections_url', window.location.pathname);

    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    });
    const state = await response.json();
    if (state.status) throw new Error(state.description);

    cart.renderContents(state);
  } catch (e) {
    console.error(e);
    btn.disabled = false;
  }
});